import Vue from "vue";
import Vuex from "vuex";

import { common } from "./common";
import { auth } from "./AuthModule";
import { sensor } from "./Sensor";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    auth,
    sensor
  },
  plugins: [
    createPersistedState({
      paths: ["save"],
    }),
  ],
});
